import { logError } from "@up/data";
import {
  getCountryCode,
  getDialingCode,
  getDialingCodeFromCountryCode,
} from "@up/form";

export const logBoundaryError = (
  error: Error,
  info: { componentStack: string },
) => {
  logError({ action: "APPLICATION_FORM_BOUNDARY_ERROR", error, context: { up_stack: info.componentStack } });
};

export function formatForServer(data: { [key: string]: string | string[] }) {
  if (
    data["student-phone-number"] &&
    !(data["student-phone-number"] as string).startsWith("+")
  ) {
    const cc = data["student-phone-number-country-code"];
    const { value: dc } = getDialingCodeFromCountryCode(cc as string);
    if (dc) {
      data["student-phone-number"] = dc + data["student-phone-number"];
    }
  }
  if (
    data["guardian-phone-number"] &&
    !(data["guardian-phone-number"] as string).startsWith("+")
  ) {
    const cc = data["guardian-phone-number-country-code"];
    const { value: dc } = getDialingCodeFromCountryCode(cc as string);
    if (dc) {
      data["guardian-phone-number"] = dc + data["guardian-phone-number"];
    }
  }

  /* Remove country code */
  delete data["student-phone-number-country-code"];
  delete data["guardian-phone-number-country-code"];

  /*
    program and cohort selection comes from the form like so:
    {
      "program-selection": ["id123", "id789"],
      "cohort-selection-id123": "idxxx",
      "cohort-selection-id789": "idzzz",
    }

    If a user deselects a program, the corresponding cohort-selection-xxxxx
    key/value pair is not removed, we must do it manually
  */
  if (data["program-selection"]) {
    Object.keys(data)
      .filter((k) => k.match(/cohort-selection-/))
      .forEach((key) => {
        const cohortId = key.split("cohort-selection-")[1];
        if (!data["program-selection"].includes(cohortId)) {
          delete data[key];
        }
      });
  }

  return data;
}

/*
  The server sends phone numbers in the E.164 format (+15554443333), we need to take off
  the dialing code so it can be edited in a separate input field
*/
export const setupPhoneNumber = function (
  key: string,
  data: { [key: string]: string },
) {
  const value = data[key];
  if (!value) {
    return;
  }

  const { value: dialingCode, error: dialingCodeError } = getDialingCode(value);
  const { value: countryCode, error: countryCodeError } = getCountryCode(value);

  if (dialingCodeError || countryCodeError) {
    return;
  }

  if (dialingCode && countryCode) {
    data[key] = data[key].replace(dialingCode, "");
    data[`${key}-country-code`] = countryCode;
  }
};
